/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_rn_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convert numbers to Roman numerals and back. Enter a number from 1 to 3999, or paste a Roman numeral to decode it.`)
};

const es_rn_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convierte números a numerales romanos y viceversa. Ingresa un número del 1 al 3999 o pega un numeral romano para decodificarlo.`)
};

const de_rn_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wandeln Sie Zahlen in römische Zahlen um und zurück. Geben Sie eine Zahl von 1 bis 3999 ein oder fügen Sie eine römische Zahl ein, um sie zu dekodieren.`)
};

const nl_rn_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converteer getallen naar Romeinse getallen en omgekeerd. Voer een getal in van 1 tot 3999, of plak een Romeins getal om het te decoderen.`)
};

const fr_rn_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Convertissez les nombres en chiffres romains et inversement. Entrez un nombre de 1 à 3999 ou collez un chiffre romain pour le décoder.`)
};

const it_rn_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converti i numeri in numerali romani e viceversa. Inserisci un numero da 1 a 3999, oppure incolla un numerale romano per decodificarlo.`)
};

const pt_br2_rn_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta números em numerais romanos e vice-versa. Digite um número de 1 a 3999 ou cole um numeral romano para decodificá-lo.`)
};

const pt_rn_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Converta números em numerais romanos e vice-versa. Introduza um número de 1 a 3999 ou cole um numeral romano para o descodificar.`)
};

const ja_rn_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`数字をローマ数字に変換し、元に戻します。1〜3999の数字を入力するか、ローマ数字を貼り付けてデコードしてください。`)
};

const zh_rn_intro = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在数字和罗马数字之间互相转换。输入一个 1 到 3999 之间的数字，或粘贴一个罗马数字进行解码。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const rn_intro = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.rn_intro(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("rn_intro", locale)
	if (locale === "en") return en_rn_intro(inputs)
	if (locale === "es") return es_rn_intro(inputs)
	if (locale === "de") return de_rn_intro(inputs)
	if (locale === "nl") return nl_rn_intro(inputs)
	if (locale === "fr") return fr_rn_intro(inputs)
	if (locale === "it") return it_rn_intro(inputs)
	if (locale === "pt-BR") return pt_br2_rn_intro(inputs)
	if (locale === "pt") return pt_rn_intro(inputs)
	if (locale === "ja") return ja_rn_intro(inputs)
	return zh_rn_intro(inputs)
};